import cloneDeep from 'lodash/cloneDeep'
import { CustomerTypes } from '@/constants/user/roles'
import Skill from '@/models-ts/Skill'
import Avatar from '@/models-ts/user/Avatar'

export default class VacancyRecruiter {
  id: number
  type: number
  name: string
  description: string
  avatar: Avatar
  website: string
  employees: number
  countries: Array<LX.Country>
  skills: Array<Skill>
  customerType: CustomerTypes
  internalCountryId?: number
  is_customer_verified?: boolean
  constructor({
    id = 0,
    type = 1,
    name = '',
    avatar = new Avatar(),
    website = '',
    employees = 0,
    countries = [],
    description = '',
    skills = [],
    customerType = CustomerTypes.INDIVIDUAL,
    internalCountryId,
    is_customer_verified = false,
  }: Partial<VacancyRecruiter>) {
    Object.assign(
      this,
      cloneDeep({
        id,
        type,
        name,
        description,
        avatar,
        website,
        employees,
        countries,
        skills,
        customerType,
        internalCountryId,
        is_customer_verified,
      })
    )
  }
  static fromServer({ id, type, name, avatar, profile, relations, is_customer_verified }: LX.VacancyRecruiter) {
    const isPerson = profile.type === CustomerTypes.INDIVIDUAL
    return new VacancyRecruiter({
      id,
      type,
      name,
      description: (isPerson ? profile.individual_description : profile.company_description) || '',
      avatar: Avatar.fromServer(avatar),
      website: isPerson ? profile.individual_website : profile.company_website,
      employees: profile.employees,
      countries: relations?.Country || [],
      skills: (relations?.Skill || []).map(Skill.fromServer),
      customerType: profile.type,
      internalCountryId: profile.internal_country_id,
      is_customer_verified: Number(is_customer_verified) === 1,
    })
  }
}
